//GLOBAL - components from npm
import React from 'react';

//STYLES
import './h5.scss';

//COMPONENTS


//SERVICES - api, conectors...


//GLOBAL STATE - redux, env...


//ASSETS - icons, images...


export default function H5({
  className,
  children,
  weight,
  color
}) {

  //GENERAL
  const mainClassName = 'typography-h5'

  //STATES


  //REDUX - Selectors


  //FUNCTIONS


  //USE EFFECTS


  return (
    <h5 className={`${mainClassName} ${className ? className : ''} ${weight ? `${mainClassName}--${weight}` : ''} ${color ? `${mainClassName}--color-${color}` : ''}`}>
      {children}
    </h5>
  )
}
